export default "__VITE_ASSET__BwmYZSiR__"